const config = {
  countries: {
    ABW: {
      en: 'Aruba',
      fr: 'Aruba',
      es: 'Aruba',
      de: 'Aruba',
      it: 'Aruba'
    },
    AFG: {
      en: 'Afghanistan',
      fr: 'Afghanistan',
      es: 'Afganistán',
      de: 'Afghanistan',
      it: 'Afghanistan'
    },
    AGO: {
      en: 'Angola',
      fr: 'Angola',
      es: 'Angola',
      de: 'Angola',
      it: 'Angola'
    },
    AIA: {
      en: 'Anguilla',
      fr: 'Anguilla',
      es: 'Anguilla',
      de: 'Anguilla',
      it: 'Anguilla'
    },
    ALA: {
      en: 'Åland Islands',
      fr: 'Îles Åland',
      es: 'Islas Åland',
      de: 'Ålandinseln',
      it: 'Isole Åland'
    },
    ALB: {
      en: 'Albania',
      fr: 'Albanie',
      es: 'Albania',
      de: 'Albanien',
      it: 'Albania'
    },
    AND: {
      en: 'Andorra',
      fr: 'Andorre',
      es: 'Andorra',
      de: 'Andorra',
      it: 'Andorra'
    },
    ARE: {
      en: 'United Arab Emirates',
      fr: 'Émirats Arabes Unis',
      es: 'Emiratos árabes unidos',
      de: 'Vereinigte Arabische Emirate',
      it: 'Emirati Arabi Uniti'
    },
    ARG: {
      en: 'Argentina',
      fr: 'Argentine',
      es: 'Argentina',
      de: 'Argentinien',
      it: 'Argentina'
    },
    ARM: {
      en: 'Armenia',
      fr: 'Arménie',
      es: 'Armenia',
      de: 'Armenien',
      it: 'Armenia'
    },
    ASM: {
      en: 'American Samoa',
      fr: 'Samoa Américaines',
      es: 'Samoa Americana',
      de: 'Amerikanisch Samoa',
      it: 'Samoa Americane'
    },
    ATA: {
      en: 'Antarctica',
      fr: 'Antarctique',
      es: 'Antártida',
      de: 'Antarktis',
      it: 'Antartide'
    },
    ATF: {
      en: 'French Southern Territories',
      fr: 'Terres Australes Françaises',
      es: 'Territorios australes franceses',
      de: 'Französische Süd- und Antarktisgebiete',
      it: 'Territori Francesi del Sud'
    },
    ATG: {
      en: 'Antigua and Barbuda',
      fr: 'Antigua-et-Barbuda',
      es: 'Antigua y barbuda',
      de: 'Antigua und Barbuda',
      it: 'Antigua e Barbuda'
    },
    AUS: {
      en: 'Australia',
      fr: 'Australie',
      es: 'Australia',
      de: 'Australien',
      it: 'Australia'
    },
    AUT: {
      en: 'Austria',
      fr: 'Autriche',
      es: 'Austria',
      de: 'Österreich',
      it: 'Austria'
    },
    AZE: {
      en: 'Azerbaijan',
      fr: 'Azerbaïdjan',
      es: 'Azerbaiyán',
      de: 'Aserbaidschan',
      it: 'Azerbaijan'
    },
    BDI: {
      en: 'Burundi',
      fr: 'Burundi',
      es: 'Burundi',
      de: 'Burundi',
      it: 'Burundi'
    },
    BEL: {
      en: 'Belgium',
      fr: 'Belgique',
      es: 'Bélgica',
      de: 'Belgien',
      it: 'Belgio'
    },
    BEN: {
      en: 'Benin',
      fr: 'Bénin',
      es: 'Benín',
      de: 'Benin',
      it: 'Benin'
    },
    BES: {
      en: 'Bonaire, Sint Eustatius and Saba',
      fr: 'Pays-Bas caribéens',
      es: 'Bonaire',
      de: 'Bonaire, Sint Eustatius und Saba',
      it: 'Isole BES'
    },
    BFA: {
      en: 'Burkina Faso',
      fr: 'Burkina Faso',
      es: 'Burkina faso',
      de: 'Burkina Faso',
      it: 'Burkina Faso'
    },
    BGD: {
      en: 'Bangladesh',
      fr: 'Bangladesh',
      es: 'Bangladesh',
      de: 'Bangladesch',
      it: 'Bangladesh'
    },
    BGR: {
      en: 'Bulgaria',
      fr: 'Bulgarie',
      es: 'Bulgaria',
      de: 'Bulgarien',
      it: 'Bulgaria'
    },
    BHR: {
      en: 'Bahrain',
      fr: 'Bahreïn',
      es: 'Bahrein',
      de: 'Bahrain',
      it: 'Bahrain'
    },
    BHS: {
      en: 'Bahamas',
      fr: 'Bahamas',
      es: 'Bahamas',
      de: 'Bahamas',
      it: 'Bahamas'
    },
    BIH: {
      en: 'Bosnia and Herzegovina',
      fr: 'Bosnie-Herzégovine',
      es: 'Bosnia-herzegovina',
      de: 'Bosnien und Herzegowina',
      it: 'Bosnia Erzegovina'
    },
    BLM: {
      en: 'Saint Barthélemy',
      fr: 'Saint-Barthélemy',
      es: 'San Bartolomé',
      de: 'Sankt Bartholomäus',
      it: 'Saint-Barthélemy'
    },
    BLR: {
      en: 'Belarus',
      fr: 'Bélarus',
      es: 'Bielorrusia',
      de: 'Belarus',
      it: 'Bielorussia'
    },
    BLZ: {
      en: 'Belize',
      fr: 'Belize',
      es: 'Belice',
      de: 'Belize',
      it: 'Belize'
    },
    BMU: {
      en: 'Bermuda',
      fr: 'Bermudes',
      es: 'Bermudas',
      de: 'Bermuda',
      it: 'Bermuda'
    },
    BOL: {
      en: 'Bolivia',
      fr: 'Bolivie',
      es: 'Bolivia',
      de: 'Bolivien',
      it: 'Bolivia'
    },
    BRA: {
      en: 'Brazil',
      fr: 'Brésil',
      es: 'Brasil',
      de: 'Brasilien',
      it: 'Brasile'
    },
    BRB: {
      en: 'Barbados',
      fr: 'Barbade',
      es: 'Barbados',
      de: 'Barbados',
      it: 'Barbados'
    },
    BRN: {
      en: 'Brunei Darussalam',
      fr: 'Brunéi Darussalam',
      es: 'Brunei darussalam',
      de: 'Brunei',
      it: 'Brunei Darussalam'
    },
    BTN: {
      en: 'Bhutan',
      fr: 'Bhoutan',
      es: 'Bután',
      de: 'Bhutan',
      it: 'Bhutan'
    },
    BVT: {
      en: 'Bouvet Island',
      fr: 'Île Bouvet',
      es: 'Isla Bouvet',
      de: 'Bouvetinsel',
      it: 'Isola di Bouvet'
    },
    BWA: {
      en: 'Botswana',
      fr: 'Botswana',
      es: 'Botswana',
      de: 'Botswana',
      it: 'Botswana'
    },
    CAF: {
      en: 'Central African Republic',
      fr: 'République Centrafricaine',
      es: 'República centroafricana',
      de: 'Zentralafrikanische Republik',
      it: 'Repubblica Centroafricana'
    },
    CAN: {
      en: 'Canada',
      fr: 'Canada',
      es: 'Cabo verde',
      de: 'Kanada',
      it: 'Canada'
    },
    CCK: {
      en: 'Cocos (Keeling) Islands',
      fr: 'Îles Cocos (Keeling)',
      es: 'Islas cocos',
      de: 'Kokosinseln',
      it: 'Isole Cocos'
    },
    CHE: {
      en: 'Switzerland',
      fr: 'Suisse',
      es: 'Suiza',
      de: 'Schweiz',
      it: 'Svizzera'
    },
    CHL: {
      en: 'Chile',
      fr: 'Chili',
      es: 'Chile',
      de: 'Chile',
      it: 'Cile'
    },
    CHN: {
      en: 'China',
      fr: 'Chine',
      es: 'China',
      de: 'China',
      it: 'Cina'
    },
    CIV: {
      en: 'Côte d\'Ivoire',
      fr: 'Côte d\'Ivoire',
      es: 'Costa de marfil',
      de: 'Elfenbeinküste',
      it: 'Costa d\'Avorio'
    },
    CMR: {
      en: 'Cameroon',
      fr: 'Cameroun',
      es: 'Canadá',
      de: 'Kamerun',
      it: 'Camerun'
    },
    COD: {
      en: 'Congo (the Democratic Republic of the)',
      fr: 'République Démocratique du Congo',
      es: 'Zaire',
      de: 'Demokratische Republik Kongo',
      it: 'Repubblica Democratica del Congo'
    },
    COG: {
      en: 'Congo (the)',
      fr: 'République du Congo',
      es: 'República del congo',
      de: 'Republik Kongo',
      it: 'Repubblica del Congo'
    },
    COK: {
      en: 'Cook Islands (the)',
      fr: 'Îles Cook',
      es: 'Islas cook',
      de: 'Cookinseln',
      it: 'Isole Cook'
    },
    COL: {
      en: 'Colombia',
      fr: 'Colombie',
      es: 'Colombia',
      de: 'Kolumbien',
      it: 'Colombia'
    },
    COM: {
      en: 'Comoros (the)',
      fr: 'Comores',
      es: 'Comores',
      de: 'Komoren',
      it: 'Comore'
    },
    CPV: {
      en: 'Cabo Verde',
      fr: 'Cap-vert',
      es: 'Camboya',
      de: 'Kap Verde',
      it: 'Capo Verde'
    },
    CRI: {
      en: 'Costa Rica',
      fr: 'Costa Rica',
      es: 'Costa rica',
      de: 'Costa Rica',
      it: 'Costa Rica'
    },
    CUB: {
      en: 'Cuba',
      fr: 'Cuba',
      es: 'Cuba',
      de: 'Kuba',
      it: 'Cuba'
    },
    CUW: {
      en: 'Curaçao',
      fr: 'Curaçao',
      es: 'Curazao',
      de: 'Curaçao',
      it: 'Curaçao'
    },
    CXR: {
      en: 'Christmas Island',
      fr: 'Île Christmas',
      es: 'Isla de navidad',
      de: 'Weihnachtsinsel',
      it: 'Isola di Natale'
    },
    CYM: {
      en: 'Cayman Islands (the)',
      fr: 'Îles Caïmanes',
      es: 'Islas caimán',
      de: 'Kaimaninseln',
      it: 'Isole Cayman'
    },
    CYP: {
      en: 'Cyprus',
      fr: 'Chypre',
      es: 'Chipre',
      de: 'Zypern',
      it: 'Cipro'
    },
    CZE: {
      en: 'Czechia',
      fr: 'République Tchèque',
      es: 'República checa',
      de: 'Tschechien',
      it: 'Repubblica Ceca'
    },
    DEU: {
      en: 'Germany',
      fr: 'Allemagne',
      es: 'Alemania',
      de: 'Deutschland',
      it: 'Germania'
    },
    DJI: {
      en: 'Djibouti',
      fr: 'Djibouti',
      es: 'Djibouti',
      de: 'Dschibuti',
      it: 'Gibuti'
    },
    DMA: {
      en: 'Dominica',
      fr: 'Dominique',
      es: 'Dominica',
      de: 'Dominica',
      it: 'Dominica'
    },
    DNK: {
      en: 'Denmark',
      fr: 'Danemark',
      es: 'Dinamarca',
      de: 'Dänemark',
      it: 'Danimarca'
    },
    DOM: {
      en: 'Dominican Republic (the)',
      fr: 'République Dominicaine',
      es: 'República dominicana',
      de: 'Dominikanische Republik',
      it: 'Repubblica Dominicana'
    },
    DZA: {
      en: 'Algeria',
      fr: 'Algérie',
      es: 'Argelia',
      de: 'Algerien',
      it: 'Algeria'
    },
    ECU: {
      en: 'Ecuador',
      fr: 'Équateur',
      es: 'Ecuador',
      de: 'Ecuador',
      it: 'Ecuador'
    },
    EGY: {
      en: 'Egypt',
      fr: 'Égypte',
      es: 'Egipto',
      de: 'Ägypten',
      it: 'Egitto'
    },
    ERI: {
      en: 'Eritrea',
      fr: 'Érythrée',
      es: 'Eritrea',
      de: 'Eritrea',
      it: 'Eritrea'
    },
    ESH: {
      en: 'Western Sahara',
      fr: 'Sahara Occidental',
      es: 'Sáhara occidental',
      de: 'Westsahara',
      it: 'Sahara Occidentale'
    },
    ESP: {
      en: 'Spain',
      fr: 'Espagne',
      es: 'España',
      de: 'Spanien',
      it: 'Spagna'
    },
    EST: {
      en: 'Estonia',
      fr: 'Estonie',
      es: 'Estonia',
      de: 'Estland',
      it: 'Estonia'
    },
    ETH: {
      en: 'Ethiopia',
      fr: 'Éthiopie',
      es: 'Etiopía',
      de: 'Äthiopien',
      it: 'Etiopia'
    },
    FIN: {
      en: 'Finland',
      fr: 'Finlande',
      es: 'Finlandia',
      de: 'Finnland',
      it: 'Finlandia'
    },
    FJI: {
      en: 'Fiji',
      fr: 'Fidji',
      es: 'Fiyi',
      de: 'Fidschi',
      it: 'Fiji'
    },
    FLK: {
      en: 'Falkland Islands (the) [Malvinas]',
      fr: 'Îles (malvinas) Falkland',
      es: 'Islas malvinas',
      de: 'Falklandinseln',
      it: 'Isole Falkland'
    },
    FRA: {
      en: 'France',
      fr: 'France métropolitaine',
      es: 'Francia',
      de: 'Frankreich',
      it: 'Francia'
    },
    FRO: {
      en: 'Faroe Islands (the)',
      fr: 'Îles Féroé',
      es: 'Islas faeroe',
      de: 'Färöer-Inseln',
      it: 'Isole Faroe'
    },
    FSM: {
      en: 'Micronesia (Federated States of)',
      fr: 'États Fédérés de Micronésie',
      es: 'Estados federados de micronesia',
      de: 'Föderierte Staaten von Mikronesien',
      it: 'Stati Federati della Micronesia'
    },
    GAB: {
      en: 'Gabon',
      fr: 'Gabon',
      es: 'Gabón',
      de: 'Gabun',
      it: 'Gabon'
    },
    GBR: {
      en: 'United Kingdom of Great Britain and Northern Ireland (the)',
      fr: 'Royaume-Uni',
      es: 'Gran bretaña',
      de: 'Vereinigtes Königreich',
      it: 'Regno Unito'
    },
    GEO: {
      en: 'Georgia',
      fr: 'Géorgie',
      es: 'Georgia',
      de: 'Georgien',
      it: 'Georgia'
    },
    GGY: {
      en: 'Guernsey',
      fr: 'Guernsey',
      es: 'Guernsey',
      de: 'Guernsey',
      it: 'Guernsey'
    },
    GHA: {
      en: 'Ghana',
      fr: 'Ghana',
      es: 'Ghana',
      de: 'Ghana',
      it: 'Ghana'
    },
    GIB: {
      en: 'Gibraltar',
      fr: 'Gibraltar',
      es: 'Gilbraltar',
      de: 'Gibraltar',
      it: 'Gibilterra'
    },
    GIN: {
      en: 'Guinea',
      fr: 'Guinée',
      es: 'República guinea',
      de: 'Guinea',
      it: 'Guinea'
    },
    GLP: {
      en: 'Guadeloupe',
      fr: 'Guadeloupe',
      es: 'Guadelupe',
      de: 'Guadeloupe',
      it: 'Guadalupa'
    },
    GMB: {
      en: 'Gambia (the)',
      fr: 'Gambie',
      es: 'Gambia',
      de: 'Gambia',
      it: 'Gambia'
    },
    GNB: {
      en: 'Guinea-Bissau',
      fr: 'Guinée-Bissau',
      es: 'Guinea bissau',
      de: 'Guinea-Bissau',
      it: 'Guinea-Bissau'
    },
    GNQ: {
      en: 'Equatorial Guinea',
      fr: 'Guinée Équatoriale',
      es: 'Guinea equatorial',
      de: 'Äquatorialguinea',
      it: 'Guinea Equatoriale'
    },
    GRC: {
      en: 'Greece',
      fr: 'Grèce',
      es: 'Grecia',
      de: 'Griechenland',
      it: 'Grecia'
    },
    GRD: {
      en: 'Grenada',
      fr: 'Grenade',
      es: 'Granada',
      de: 'Grenada',
      it: 'Grenada'
    },
    GRL: {
      en: 'Greenland',
      fr: 'Groenland',
      es: 'Groenlandia',
      de: 'Grönland',
      it: 'Groenlandia'
    },
    GTM: {
      en: 'Guatemala',
      fr: 'Guatemala',
      es: 'Guatemala',
      de: 'Guatemala',
      it: 'Guatemala'
    },
    GUF: {
      en: 'French Guiana',
      fr: 'Guyane Française',
      es: 'Guinea francés',
      de: 'Französisch-Guayana',
      it: 'Guyana Francese'
    },
    GUM: {
      en: 'Guam',
      fr: 'Guam',
      es: 'Guam',
      de: 'Guam',
      it: 'Guam'
    },
    GUY: {
      en: 'Guyana',
      fr: 'Guyana',
      es: 'Guyana',
      de: 'Guyana',
      it: 'Guyana'
    },
    HKG: {
      en: 'Hong Kong',
      fr: 'Hong-Kong',
      es: 'Hong kong',
      de: 'Hongkong',
      it: 'Hong Kong'
    },
    HMD: {
      en: 'Heard Island and McDonald Islands',
      fr: 'Îles Heard et Mcdonald',
      es: 'Islas de heard y mcdonald',
      de: 'Heard und McDonald Inseln',
      it: 'Isola Heard e Isole McDonald'
    },
    HND: {
      en: 'Honduras',
      fr: 'Honduras',
      es: 'Honduras',
      de: 'Honduras',
      it: 'Honduras'
    },
    HRV: {
      en: 'Croatia',
      fr: 'Croatie',
      es: 'Croatie',
      de: 'Kroatien',
      it: 'Croazia'
    },
    HTI: {
      en: 'Haiti',
      fr: 'Haïti',
      es: 'Haiti',
      de: 'Haiti',
      it: 'Haiti'
    },
    HUN: {
      en: 'Hungary',
      fr: 'Hongrie',
      es: 'Hungría',
      de: 'Ungarn',
      it: 'Ungheria'
    },
    ICA: {
      en: "Canary Islands",
      fr: "Îles Canaries",
      es: "Islas Canarias",
      de: "Kanarische Inseln",
      it: "isole Canarie"
    },
    IDN: {
      en: 'Indonesia',
      fr: 'Indonésie',
      es: 'Indonesia',
      de: 'Indonesien',
      it: 'Indonesia'
    },
    IMN: {
      en: 'Isle of Man',
      fr: 'Île de Man',
      es: 'Isla de Man',
      de: 'Insel Man',
      it: 'Isola di Man'
    },
    IND: {
      en: 'India',
      fr: 'Inde',
      es: 'India',
      de: 'Indien',
      it: 'India'
    },
    IOT: {
      en: 'British Indian Ocean Territory (the)',
      fr: 'Territoire Britannique de l\'Océan Indien',
      es: 'Territorio británico del océano índico',
      de: 'Britisches Territorium im Indischen Ozean',
      it: 'Territori Britannici dell\'Oceano Indiano'
    },
    IRL: {
      en: 'Ireland',
      fr: 'Irlande',
      es: 'Irlanda',
      de: 'Irland',
      it: 'Eire'
    },
    IRN: {
      en: 'Iran (Islamic Republic of)',
      fr: 'République Islamique d\'Iran',
      es: 'Irán',
      de: 'Iran',
      it: 'Iran'
    },
    IRQ: {
      en: 'Iraq',
      fr: 'Iraq',
      es: 'Iraq',
      de: 'Irak',
      it: 'Iraq'
    },
    ISL: {
      en: 'Iceland',
      fr: 'Islande',
      es: 'Islandia',
      de: 'Island',
      it: 'Islanda'
    },
    ISR: {
      en: 'Israel',
      fr: 'Israël',
      es: 'Israel',
      de: 'Israel',
      it: 'Israele'
    },
    ITA: {
      en: 'Italy',
      fr: 'Italie',
      es: 'Italia',
      de: 'Italien',
      it: 'Italia'
    },
    JAM: {
      en: 'Jamaica',
      fr: 'Jamaïque',
      es: 'Jamaica',
      de: 'Jamaika',
      it: 'Giamaica'
    },
    JEY: {
      en: 'Jersey',
      fr: 'Jersey',
      es: 'Jersey',
      de: 'Jersey',
      it: 'Jersey'
    },
    JOR: {
      en: 'Jordan',
      fr: 'Jordanie',
      es: 'Jordania',
      de: 'Jordanien',
      it: 'Giordania'
    },
    JPN: {
      en: 'Japan',
      fr: 'Japon',
      es: 'Japón',
      de: 'Japan',
      it: 'Giappone'
    },
    KAZ: {
      en: 'Kazakhstan',
      fr: 'Kazakhstan',
      es: 'Kazajstán',
      de: 'Kasachstan',
      it: 'Kazakhistan'
    },
    KEN: {
      en: 'Kenya',
      fr: 'Kenya',
      es: 'Kenia',
      de: 'Kenia',
      it: 'Kenya'
    },
    KGZ: {
      en: 'Kyrgyzstan',
      fr: 'Kirghizistan',
      es: 'Kirguistán',
      de: 'Kirgisistan',
      it: 'Kirghizistan'
    },
    KHM: {
      en: 'Cambodia',
      fr: 'Cambodge',
      es: 'Camerún',
      de: 'Kambodscha',
      it: 'Cambogia'
    },
    KIR: {
      en: 'Kiribati',
      fr: 'Kiribati',
      es: 'Kiribati',
      de: 'Kiribati',
      it: 'Kiribati'
    },
    KNA: {
      en: 'Saint Kitts and Nevis',
      fr: 'Saint-Kitts-et-Nevis',
      es: 'San cristobal y nevis',
      de: 'St. Kitts und Nevis',
      it: 'Saint Kitts e Nevis'
    },
    KOR: {
      en: 'Korea (the Republic of)',
      fr: 'République de Corée',
      es: 'Corea del sur',
      de: 'Südkorea',
      it: 'Corea del Sud'
    },
    KWT: {
      en: 'Kuwait',
      fr: 'Koweït',
      es: 'Kuwait',
      de: 'Kuwait',
      it: 'Kuwait'
    },
    LAO: {
      en: 'Lao People\'s Democratic Republic (the)',
      fr: 'République Démocratique Populaire Lao',
      es: 'Laos',
      de: 'Laos',
      it: 'Laos'
    },
    LBN: {
      en: 'Lebanon',
      fr: 'Liban',
      es: 'Líbano',
      de: 'Libanon',
      it: 'Libano'
    },
    LBR: {
      en: 'Liberia',
      fr: 'Libéria',
      es: 'Liberia',
      de: 'Liberia',
      it: 'Liberia'
    },
    LBY: {
      en: 'Libya',
      fr: 'Jamahiriya Arabe Libyenne',
      es: 'Libia',
      de: 'Libyen',
      it: 'Libia'
    },
    LCA: {
      en: 'Saint Lucia',
      fr: 'Sainte-Lucie',
      es: 'Santa lucía',
      de: 'St. Lucia',
      it: 'Santa Lucia'
    },
    LIE: {
      en: 'Liechtenstein',
      fr: 'Liechtenstein',
      es: 'Liechtenstein',
      de: 'Liechtenstein',
      it: 'Liechtenstein'
    },
    LKA: {
      en: 'Sri Lanka',
      fr: 'Sri Lanka',
      es: 'Sri lanka',
      de: 'Sri Lanka',
      it: 'Sri Lanka'
    },
    LSO: {
      en: 'Lesotho',
      fr: 'Lesotho',
      es: 'Lesotho',
      de: 'Lesotho',
      it: 'Lesotho'
    },
    LTU: {
      en: 'Lithuania',
      fr: 'Lituanie',
      es: 'Lituania',
      de: 'Litauen',
      it: 'Lituania'
    },
    LUX: {
      en: 'Luxembourg',
      fr: 'Luxembourg',
      es: 'Luxemburgo',
      de: 'Luxemburg',
      it: 'Lussemburgo'
    },
    LVA: {
      en: 'Latvia',
      fr: 'Lettonie',
      es: 'Letonia',
      de: 'Lettland',
      it: 'Lettonia'
    },
    MAC: {
      en: 'Macao',
      fr: 'Macao',
      es: 'Macao',
      de: 'Macau',
      it: 'Macao'
    },
    MAF: {
      en: 'Saint Martin (French part)',
      fr: 'Saint-Martin',
      es: 'San martín',
      de: 'Saint Martin',
      it: 'Saint-Martin'
    },
    MAR: {
      en: 'Morocco',
      fr: 'Maroc',
      es: 'Marruecos',
      de: 'Marokko',
      it: 'Marocco'
    },
    MCO: {
      en: 'Monaco',
      fr: 'Monaco',
      es: 'Mónaco',
      de: 'Fürstentum Monaco',
      it: 'Monaco'
    },
    MDA: {
      en: 'Moldova (the Republic of)',
      fr: 'République de Moldova',
      es: 'Moldavia',
      de: 'Moldawien',
      it: 'Moldavia'
    },
    MDG: {
      en: 'Madagascar',
      fr: 'Madagascar',
      es: 'Madagascar',
      de: 'Madagaskar',
      it: 'Madagascar'
    },
    MDV: {
      en: 'Maldives',
      fr: 'Maldives',
      es: 'Maldivas',
      de: 'Malediven',
      it: 'Maldive'
    },
    MEX: {
      en: 'Mexico',
      fr: 'Mexique',
      es: 'México',
      de: 'Mexiko',
      it: 'Messico'
    },
    MHL: {
      en: 'Marshall Islands (the)',
      fr: 'Îles Marshall',
      es: 'Islas marshall',
      de: 'Marshallinseln',
      it: 'Isole Marshall'
    },
    MKD: {
      en: 'Macedonia (the former Yugoslav Republic of)',
      fr: 'L\'ex-République Yougoslave de Macédoine',
      es: 'Macedonia',
      de: 'Nordmazedonien',
      it: 'Macedonia'
    },
    MLI: {
      en: 'Mali',
      fr: 'Mali',
      es: 'Malí',
      de: 'Mali',
      it: 'Mali'
    },
    MLT: {
      en: 'Malta',
      fr: 'Malte',
      es: 'Malta',
      de: 'Malta',
      it: 'Malta'
    },
    MMR: {
      en: 'Myanmar',
      fr: 'Myanmar',
      es: 'Myanmar',
      de: 'Myanmar',
      it: 'Myanmar'
    },
    MNE: {
      en: 'Montenegro',
      fr: 'Monténégro',
      es: 'Montenegro',
      de: 'Montenegro',
      it: 'Montenegro'
    },
    MNG: {
      en: 'Mongolia',
      fr: 'Mongolie',
      es: 'Mongolia',
      de: 'Mongolei',
      it: 'Mongolia'
    },
    MNP: {
      en: 'Northern Mariana Islands (the)',
      fr: 'Îles Mariannes du Nord',
      es: 'Marianas del norte',
      de: 'Nördliche Marianen',
      it: 'Isole Marianne Settentrionali'
    },
    MOZ: {
      en: 'Mozambique',
      fr: 'Mozambique',
      es: 'Mozambique',
      de: 'Mosambik',
      it: 'Mozambico'
    },
    MRT: {
      en: 'Mauritania',
      fr: 'Mauritanie',
      es: 'Mauritania',
      de: 'Mauretanien',
      it: 'Mauritania'
    },
    MSR: {
      en: 'Montserrat',
      fr: 'Montserrat',
      es: 'Montserrat',
      de: 'Montserrat',
      it: 'Montserrat'
    },
    MTQ: {
      en: 'Martinique',
      fr: 'Martinique',
      es: 'Martinica',
      de: 'Martinique',
      it: 'Martinica'
    },
    MUS: {
      en: 'Mauritius',
      fr: 'Maurice',
      es: 'Maurice',
      de: 'Mauritius',
      it: 'Maurizius'
    },
    MWI: {
      en: 'Malawi',
      fr: 'Malawi',
      es: 'Malawi',
      de: 'Malawi',
      it: 'Malawi'
    },
    MYS: {
      en: 'Malaysia',
      fr: 'Malaisie',
      es: 'Malasia',
      de: 'Malaysia',
      it: 'Malesia'
    },
    MYT: {
      en: 'Mayotte',
      fr: 'Mayotte',
      es: 'Mayotte',
      de: 'Mayotte',
      it: 'Mayotte'
    },
    NAM: {
      en: 'Namibia',
      fr: 'Namibie',
      es: 'Namibia',
      de: 'Namibia',
      it: 'Namibia'
    },
    NCL: {
      en: 'New Caledonia',
      fr: 'Nouvelle-Calédonie',
      es: 'Nueva caledonia',
      de: 'Neukaledonien',
      it: 'Nuova Caledonia'
    },
    NER: {
      en: 'Niger (the)',
      fr: 'Niger',
      es: 'Niger',
      de: 'Niger',
      it: 'Niger'
    },
    NFK: {
      en: 'Norfolk Island',
      fr: 'Île Norfolk',
      es: 'Isla norfolk',
      de: 'Norfolkinsel',
      it: 'Isola Norfolk'
    },
    NGA: {
      en: 'Nigeria',
      fr: 'Nigéria',
      es: 'Nigeria',
      de: 'Nigeria',
      it: 'Nigeria'
    },
    NIC: {
      en: 'Nicaragua',
      fr: 'Nicaragua',
      es: 'Nicaragua',
      de: 'Nicaragua',
      it: 'Nicaragua'
    },
    NIU: {
      en: 'Niue',
      fr: 'Niué',
      es: 'Niue',
      de: 'Niue',
      it: 'Niue'
    },
    NLD: {
      en: 'Netherlands (the)',
      fr: 'Pays-Bas',
      es: 'Holanda o paí ses bajos',
      de: 'Niederlande',
      it: 'Paesi Bassi'
    },
    NOR: {
      en: 'Norway',
      fr: 'Norvège',
      es: 'Noruega',
      de: 'Norwegen',
      it: 'Norvegia'
    },
    NPL: {
      en: 'Nepal',
      fr: 'Népal',
      es: 'Nepal',
      de: 'Nepal',
      it: 'Nepal'
    },
    NRU: {
      en: 'Nauru',
      fr: 'Nauru',
      es: 'Nauru',
      de: 'Nauru',
      it: 'Nauru'
    },
    NZL: {
      en: 'New Zealand',
      fr: 'Nouvelle-Zélande',
      es: 'Nueva zelanda',
      de: 'Neuseeland',
      it: 'Nuova Zelanda'
    },
    OMN: {
      en: 'Oman',
      fr: 'Oman',
      es: 'Omán',
      de: 'Oman',
      it: 'Oman'
    },
    PAK: {
      en: 'Pakistan',
      fr: 'Pakistan',
      es: 'Pakistán',
      de: 'Pakistan',
      it: 'Pakistan'
    },
    PAN: {
      en: 'Panama',
      fr: 'Panama',
      es: 'Panamá',
      de: 'Panama',
      it: 'Panama'
    },
    PCN: {
      en: 'Pitcairn',
      fr: 'Pitcairn',
      es: 'Isla pitcaim',
      de: 'Pitcairninseln',
      it: 'Pitcairn'
    },
    PER: {
      en: 'Peru',
      fr: 'Pérou',
      es: 'Perú',
      de: 'Peru',
      it: 'Peru'
    },
    PHL: {
      en: 'Philippines (the)',
      fr: 'Philippines',
      es: 'Filipinas',
      de: 'Philippinen',
      it: 'Filippine'
    },
    PLW: {
      en: 'Palau',
      fr: 'Palaos',
      es: 'Palau',
      de: 'Palau',
      it: 'Palau'
    },
    PNG: {
      en: 'Papua New Guinea',
      fr: 'Papouasie-Nouvelle-Guinée',
      es: 'Papúa-nuevo guinea',
      de: 'Papua-Neuguinea',
      it: 'Papua Nuova Guinea'
    },
    POL: {
      en: 'Poland',
      fr: 'Pologne',
      es: 'Polonia',
      de: 'Polen',
      it: 'Polonia'
    },
    PRI: {
      en: 'Puerto Rico',
      fr: 'Porto Rico',
      es: 'Puerto Rico',
      de: 'Puerto Rico',
      it: 'Porto Rico'
    },
    PRK: {
      en: 'Korea (the Democratic People\'s Republic of)',
      fr: 'République Populaire Démocratique de Corée',
      es: 'Corea norte',
      de: 'Nordkorea',
      it: 'Corea del Nord'
    },
    PRT: {
      en: 'Portugal',
      fr: 'Portugal',
      es: 'Portugal',
      de: 'Portugal',
      it: 'Portogallo'
    },
    PRY: {
      en: 'Paraguay',
      fr: 'Paraguay',
      es: 'Paraguay',
      de: 'Paraguay',
      it: 'Paraguay'
    },
    PSE: {
      en: 'Palestine, State of',
      fr: 'Territoire Palestinien Occupé',
      es: 'Estado de Palestina',
      de: 'Palästina',
      it: 'Territori Palestinesi Occupati'
    },
    PYF: {
      en: 'French Polynesia',
      fr: 'Polynésie Française',
      es: 'Polinesia francesa',
      de: 'Französisch-Polynesien',
      it: 'Polinesia Francese'
    },
    QAT: {
      en: 'Qatar',
      fr: 'Qatar',
      es: 'Qatar',
      de: 'Katar',
      it: 'Qatar'
    },
    REU: {
      en: 'Réunion',
      fr: 'Réunion',
      es: 'Reunión',
      de: 'Réunion',
      it: 'Reunion'
    },
    ROU: {
      en: 'Romania',
      fr: 'Roumanie',
      es: 'Rumanía',
      de: 'Rumänien',
      it: 'Romania'
    },
    RUS: {
      en: 'Russian Federation (the)',
      fr: 'Fédération de Russie',
      es: 'Rusa',
      de: 'Russland',
      it: 'Federazione Russa'
    },
    RWA: {
      en: 'Rwanda',
      fr: 'Rwanda',
      es: 'Ruanda',
      de: 'Ruanda',
      it: 'Ruanda'
    },
    SAU: {
      en: 'Saudi Arabia',
      fr: 'Arabie Saoudite',
      es: 'Arabia saudita',
      de: 'Saudi-Arabien',
      it: 'Arabia Saudita'
    },
    SDN: {
      en: 'Sudan (the)',
      fr: 'Soudan',
      es: 'Subán',
      de: 'Sudan',
      it: 'Sudan'
    },
    SEN: {
      en: 'Senegal',
      fr: 'Sénégal',
      es: 'Senegal',
      de: 'Senegal',
      it: 'Senegal'
    },
    SGP: {
      en: 'Singapore',
      fr: 'Singapour',
      es: 'Singapur',
      de: 'Singapur',
      it: 'Singapore'
    },
    SGS: {
      en: 'South Georgia and the South Sandwich Islands',
      fr: 'Géorgie du Sud et les Îles Sandwich du Sud',
      es: 'Sudo georgia',
      de: 'Südgeorgien und die Südlichen Sandwichinseln',
      it: 'Sud Georgia e Isole Sandwich'
    },
    SHN: {
      en: 'Saint Helena, Ascension and Tristan da Cunha',
      fr: 'Sainte-Hélène',
      es: 'Santa elena',
      de: 'St. Helena, Ascension und Tristan da Cunha',
      it: 'Sant\'Elena'
    },
    SJM: {
      en: 'Svalbard and Jan Mayen',
      fr: 'Svalbard et Île Jan Mayen',
      es: 'Isla jan mayen y archipiélago de svalbard',
      de: 'Svalbard und Jan Mayen',
      it: 'Svalbard e Jan Mayen'
    },
    SLB: {
      en: 'Solomon Islands',
      fr: 'Îles Salomon',
      es: 'Islas salomón',
      de: 'Salomonen',
      it: 'Isole Solomon'
    },
    SLE: {
      en: 'Sierra Leone',
      fr: 'Sierra Leone',
      es: 'Sierra leona',
      de: 'Sierra Leone',
      it: 'Sierra Leone'
    },
    SLV: {
      en: 'El Salvador',
      fr: 'El Salvador',
      es: 'El salvador',
      de: 'El Salvador',
      it: 'El Salvador'
    },
    SMR: {
      en: 'San Marino',
      fr: 'Saint-Marin',
      es: 'San marino',
      de: 'San Marino',
      it: 'San Marino'
    },
    SOM: {
      en: 'Somalia',
      fr: 'Somalie',
      es: 'Somalia',
      de: 'Somalia',
      it: 'Somalia'
    },
    SPM: {
      en: 'Saint Pierre and Miquelon',
      fr: 'Saint-Pierre-et-Miquelon',
      es: 'San pedro y miquelón',
      de: 'St. Pierre und Miquelon',
      it: 'Saint Pierre e Miquelon'
    },
    SRB: {
      en: 'Serbia',
      fr: 'République de Serbie',
      es: 'Yugoslavia',
      de: 'Serbien',
      it: 'Serbia'
    },
    SSD: {
      en: 'South Sudan',
      fr: 'Soudan du Sud',
      es: 'Sudán del Sur',
      de: 'Südsudan',
      it: 'Sudan del Sud'
    },
    STP: {
      en: 'Sao Tome and Principe',
      fr: 'Sao Tomé-et-Principe',
      es: 'San toméy príncipe',
      de: 'São Tomé und Príncipe',
      it: 'Sao Tome e Principe'
    },
    SUR: {
      en: 'Suriname',
      fr: 'Suriname',
      es: 'Surinam',
      de: 'Suriname',
      it: 'Suriname'
    },
    SVK: {
      en: 'Slovakia',
      fr: 'Slovaquie',
      es: 'Eslovaquia',
      de: 'Slowakei',
      it: 'Slovacchia'
    },
    SVN: {
      en: 'Slovenia',
      fr: 'Slovénie',
      es: 'Eslovenia',
      de: 'Slowenien',
      it: 'Slovenia'
    },
    SWE: {
      en: 'Sweden',
      fr: 'Suède',
      es: 'Suecia',
      de: 'Schweden',
      it: 'Svezia'
    },
    SWZ: {
      en: 'Swaziland',
      fr: 'Swaziland',
      es: 'Swazilandia',
      de: 'Eswatini',
      it: 'Swaziland'
    },
    SXM: {
      en: 'Sint Maarten (Dutch part)',
      fr: 'Sint Maarten',
      es: 'San maarten',
      de: 'Sint Maarten',
      it: 'Sint Maarten'
    },
    SYC: {
      en: 'Seychelles',
      fr: 'Seychelles',
      es: 'Seychelles',
      de: 'Seychellen',
      it: 'Seychelles'
    },
    SYR: {
      en: 'Syrian Arab Republic',
      fr: 'République Arabe Syrienne',
      es: 'Siria',
      de: 'Syrien',
      it: 'Siria'
    },
    TCA: {
      en: 'Turks and Caicos Islands (the)',
      fr: 'Îles Turks et Caïques',
      es: 'Islas turcas y caicos',
      de: 'Turks und Caicosinseln',
      it: 'Isole Turks e Caicos'
    },
    TCD: {
      en: 'Chad',
      fr: 'Tchad',
      es: 'Chad',
      de: 'Tschad',
      it: 'Ciad'
    },
    TGO: {
      en: 'Togo',
      fr: 'Togo',
      es: 'Togo',
      de: 'Togo',
      it: 'Togo'
    },
    THA: {
      en: 'Thailand',
      fr: 'Thaïlande',
      es: 'Taílandia',
      de: 'Thailand',
      it: 'Tailandia'
    },
    TJK: {
      en: 'Tajikistan',
      fr: 'Tadjikistan',
      es: 'Tadjikistan',
      de: 'Tadschikistan',
      it: 'Tagikistan'
    },
    TKL: {
      en: 'Tokelau',
      fr: 'Tokelau',
      es: 'Tokelau',
      de: 'Tokelau',
      it: 'Tokelau'
    },
    TKM: {
      en: 'Turkmenistan',
      fr: 'Turkménistan',
      es: 'Turkmenistan',
      de: 'Turkmenistan',
      it: 'Turkmenistan'
    },
    TLS: {
      en: 'Timor-Leste',
      fr: 'Timor-Leste',
      es: 'Timor oriental',
      de: 'Osttimor',
      it: 'Timor Est'
    },
    TON: {
      en: 'Tonga',
      fr: 'Tonga',
      es: 'Tonga',
      de: 'Tonga',
      it: 'Tonga'
    },
    TTO: {
      en: 'Trinidad and Tobago',
      fr: 'Trinité-et-Tobago',
      es: 'Trinidad y tobago',
      de: 'Trinidad und Tobago',
      it: 'Trinidad e Tobago'
    },
    TUN: {
      en: 'Tunisia',
      fr: 'Tunisie',
      es: 'Túnez',
      de: 'Tunesien',
      it: 'Tunisia'
    },
    TUR: {
      en: 'Turkey',
      fr: 'Turquie',
      es: 'Turquía',
      de: 'Türkei',
      it: 'Turchia'
    },
    TUV: {
      en: 'Tuvalu',
      fr: 'Tuvalu',
      es: 'Tuvalu',
      de: 'Tuvalu',
      it: 'Tuvalu'
    },
    TWN: {
      en: 'Taiwan (Province of China)',
      fr: 'Taïwan',
      es: 'Taiwan',
      de: 'Taiwan',
      it: 'Taiwan'
    },
    TZA: {
      en: 'Tanzania, United Republic of',
      fr: 'République-Unie de Tanzanie',
      es: 'Tanzania',
      de: 'Tansania',
      it: 'Tanzania'
    },
    UGA: {
      en: 'Uganda',
      fr: 'Ouganda',
      es: 'Uganda',
      de: 'Uganda',
      it: 'Uganda'
    },
    UKR: {
      en: 'Ukraine',
      fr: 'Ukraine',
      es: 'Ucrania',
      de: 'Ukraine',
      it: 'Ucraina'
    },
    UMI: {
      en: 'United States Minor Outlying Islands (the)',
      fr: 'Îles Mineures Éloignées des États-Unis',
      es: 'Islas menores de los estados unidos',
      de: 'Kleinere abgelegene Inseln der Vereinigten Staaten',
      it: 'Isole Minori degli Stati Uniti d\'America'
    },
    URY: {
      en: 'Uruguay',
      fr: 'Uruguay',
      es: 'Uruguay',
      de: 'Uruguay',
      it: 'Uruguay'
    },
    USA: {
      en: 'United States of America (the)',
      fr: 'États-Unis',
      es: 'Estados unidos',
      de: 'Vereinigte Staaten von Amerika',
      it: 'Stati Uniti d\'America'
    },
    UZB: {
      en: 'Uzbekistan',
      fr: 'Ouzbékistan',
      es: 'Uzbekistán',
      de: 'Usbekistan',
      it: 'Uzbekistan'
    },
    VAT: {
      en: 'Holy See (the)',
      fr: 'Saint-Siège (état de la Cité du Vatican)',
      es: 'Ciudad vaticano',
      de: 'Vatikanstadt',
      it: 'Citta del Vaticano'
    },
    VCT: {
      en: 'Saint Vincent and the Grenadines',
      fr: 'Saint-Vincent-et-les Grenadines',
      es: 'San vincente y granadinas',
      de: 'St. Vincent und die Grenadinen',
      it: 'Saint Vincent e Grenadine'
    },
    VEN: {
      en: 'Venezuela (Bolivarian Republic of)',
      fr: 'Venezuela',
      es: 'Venezuela',
      de: 'Venezuela',
      it: 'Venezuela'
    },
    VGB: {
      en: 'Virgin Islands (British)',
      fr: 'Îles Vierges Britanniques',
      es: 'Islas virgenes británicas',
      de: 'Jungferninseln (UK)',
      it: 'Isole Vergini Britanniche'
    },
    VIR: {
      en: 'Virgin Islands (U.S.)',
      fr: 'Îles Vierges des États-Unis',
      es: 'Islas Vírgenes de los Estados Unidos',
      de: 'Jungferninseln (US)',
      it: 'Isole Vergini Americane'
    },
    VNM: {
      en: 'Viet Nam',
      fr: 'Viet Nam',
      es: 'Vietnam',
      de: 'Vietnam',
      it: 'Vietnam'
    },
    VUT: {
      en: 'Vanuatu',
      fr: 'Vanuatu',
      es: 'Vanatu',
      de: 'Vanuatu',
      it: 'Vanuatu'
    },
    WLF: {
      en: 'Wallis and Futuna',
      fr: 'Wallis et Futuna',
      es: 'Wallis y futuna',
      de: 'Wallis und Futuna',
      it: 'Wallis e Futuna'
    },
    WSM: {
      en: 'Samoa',
      fr: 'Samoa',
      es: 'Samoa',
      de: 'Samoa',
      it: 'Samoa'
    },
    YEM: {
      en: 'Yemen',
      fr: 'Yémen',
      es: 'Yemen',
      de: 'Jemen',
      it: 'Yemen'
    },
    ZAF: {
      en: 'South Africa',
      fr: 'Afrique du Sud',
      es: 'Sudáfrica',
      de: 'Südafrika',
      it: 'Sud Africa'
    },
    ZMB: {
      en: 'Zambia',
      fr: 'Zambie',
      es: 'Zambia',
      de: 'Sambia',
      it: 'Zambia'
    },
    ZWE: {
      en: 'Zimbabwe',
      fr: 'Zimbabwe',
      es: 'Zimbabwe',
      de: 'Simbabwe',
      it: 'Zimbabwe'
    }
  },
  genders: {
    // Salesforce API key
    // Ladies first
    Madame: {
      fr: 'Mme.',
      en: 'Mrs.',
      es: 'Sra.',
      it: 'Sig.',
      de: 'Frau.'
    },
    Monsieur: {
      fr: 'M.',
      en: 'Mr.',
      es: 'Sr.',
      it: 'Sig.ra',
      de: 'Herr.'
    }
  },
  palyanceCgs: {
    fr: 'https://palyance.com/cgs/',
    en: 'https://palyance.com/cgs/',
    es: 'https://palyance.com/es/cgs/',
    it: 'https://palyance.com/it/cgs/',
    de: 'https://palyance.com/de/cgs/'
  }
};

export default config;



// WEBPACK FOOTER //
// ./config/global-config.js